var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaestroLightLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maestro-light-large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 48,
    height: 32,
    rx: 4,
    fill: "#dfe3e8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maestro",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 38.71,
    height: 25.6,
    transform: "translate(0.65 0.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 10.21,
    height: 16.68,
    transform: "translate(14.9 4.66)",
    fill: "#7272b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.169,10.61a10.58,10.58,0,0,1,4-8.34,10.61,10.61,0,1,0,0,16.68A10.58,10.58,0,0,1,13.169,10.61Z",
    transform: "translate(2.831 2.39)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.5.411H.43V0h.1L.66.29.78,0h.1V.409H.81V.1L.7.37H.62L.5.1V.41ZM.2.41H.14V.07H0V0H.35V.07H.2V.409Z",
    transform: "translate(35.94 19.16)",
    fill: "#00a1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M17.16,10.6A10.61,10.61,0,0,1,0,18.943,10.61,10.61,0,0,0,1.78,4.053,10.4,10.4,0,0,0,0,2.263,10.61,10.61,0,0,1,17.16,10.6Z",
    transform: "translate(20 2.397)",
    fill: "#00a1de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestroLightLarge);
export default __webpack_public_path__ + "static/media/maestro-light-large.54fc798173685da1100924f97a8590a4.svg";
export { ForwardRef as ReactComponent };